import { Component, EventEmitter, Output } from '@angular/core';
import { DeliveryChannelPreferences } from 'src/app/shared/models/MFAPreferencesResponse';
import { MFAPreferencesService } from 'src/app/services/mfaPreferences/mfaPreferences.service';
import { Observable, catchError, map, of, take } from 'rxjs';
import { AsyncPipe } from '@angular/common';

export const CHANNEL_STATE = 0;
export const PIN_STATE = 1;

@Component({
  selector: 'wpro-step-up',
  templateUrl: './step-up.component.html',
  styleUrls: ['./step-up.component.css'],
  standalone: false
})
export class StepUpComponent {
  @Output() verified = new EventEmitter<boolean>();
  /** NOTE for WLGN Shared Library
   * Add a spinner before GET MFA Preference.
   */

  /**
   * TODO: Methods to be pulled from FR SDK callbacks from the step-up.service file.
   */
  channels$ = this.mfaPreferencesService.getUserMFAPreferences(true).pipe(
    take(1),
    map(response => response.output.deliveryChannelPreferences),
    catchError((err) => {
      this.isVerified(false);
      return of(null);
    })
  );
  step: number = CHANNEL_STATE;
  deliveryMethod: string;
  value: string;
  showDiffMethodLink: boolean;

  constructor(
    private mfaPreferencesService: MFAPreferencesService
  ) {}

  selectedChannel(output: { channel: DeliveryChannelPreferences; showDiffMethodLinkStatus: boolean }): void {
    if (output.channel && output.channel.deliveryMethod) {
      this.step++;
      this.deliveryMethod = output.channel.deliveryMethod;
      this.value = output.channel.value;
      this.showDiffMethodLink = output.showDiffMethodLinkStatus;
    } else {
      this.step--;
    }
  }

  /**
   * Returns an Observable that emits once when step-up completes.
   * true  = user passed authentication.
   * false = user cancelled or failed.
   *
   * Consumers that open this component as a Popr modal should subscribe to
   * this instead of @Output verified directly.
   */
  isSteppedUp$(): Observable<boolean> {
    return this.verified.asObservable();
  }

  isVerified(flag: boolean): void {
    this.verified.next(flag);
    this.verified.complete();
  }

  protected readonly CHANNEL_STATE = CHANNEL_STATE;
  protected readonly PIN_STATE = PIN_STATE;
}
